/**
 * GoalContentPageV2 — the Topics list page (V2 redesign).
 *
 * Topics (the onboarding goals) can be created and retired but never deleted.
 * The body (GoalContentTableV2) lists them in display order and links each to
 * its edit page and its session list; the "New topic" action opens the create
 * page. The Topic-based Recommended switch sits above the table.
 */
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import GoalContentTableV2 from '../../../GoalContentTable/v2/GoalContentTableV2';
import TopicRecommendedSwitch from './TopicRecommendedSwitch';
import { PageHeader, Button } from '../../../redesign';

export default function GoalContentPageV2() {
  const total = useSelector((s) =>
    Array.isArray(s.goalContent?.goalContents) ? s.goalContent.goalContents.length : undefined,
  );
  const totalLabel = total != null ? `${total.toLocaleString()} topics` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Engagement & Promotions"
        title="Topics"
        total={totalLabel}
        actions={
          <Link to="/goal-content/new" className="no-underline">
            <Button variant="coral">+ New topic</Button>
          </Link>
        }
      />
      <TopicRecommendedSwitch />
      <GoalContentTableV2 />
    </div>
  );
}
